import 'react-app-polyfill/ie11';

import { createBrowserHistory } from 'history';
import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Router } from 'react-router';

import App from './App';

const history = createBrowserHistory();

ReactDOM.render(
  <Router history={history}>
    <Route component={App} />
  </Router>,
  document.getElementById('root')
);
